import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'demo-upp-date-picker',
    templateUrl: './demo-upp-date-picker.html',
    styleUrls: ['../demo-common.scss', './demo-upp-date-picker.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppDatePickerComponent implements OnInit {
    form!: FormGroup;
    disabled = false;

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            date: new FormControl('04/04/2026')
        });
    }

    toggleDisabled(): void {
        this.disabled = !this.disabled;
        const control = this.form.get('date');
        if (this.disabled){
            control?.disable();
        }
        else {
            control?.enable();
        }
        this.change.markForCheck();
    }
}
